import type { BoardPollsState } from './types'

interface StateWithBoardPolls {
  communicationBoardPolls: BoardPollsState
}

export const selectBoardPollsState = (state: StateWithBoardPolls) => state.communicationBoardPolls
